'use strict';

var KeyMirror = require('keymirror');

module.exports = {
    ApiResponseMessage: {
        SELECT_MODEL_PORTFOLIO: 'Select model portfolio',
        NO_MODEL_PORTFOLIO_SETUP: 'No model portfolio set-up',
        SELECT_PORTFOLIO: 'Or select/search for managed account or model portfolio',
        NO_PORTFOLIO_SETUP: 'No portfolio set-up'
    },
    ActionTypes: KeyMirror({
        RECEIVE_MODEL_PORTFOLIO_LIST: null,
        RECEIVE_INVESTMENT_OPTION_LIST: null,
        RECEIVE_ALLOCATED_INVESTMENT_OPTIONS: null,
        SEARCH_INVESTMENT_OPTIONS: null,
        ADD_INVESTMENT_OPTION: null,
        REMOVE_INVESTMENT_OPTION: null,
        UPDATE_INVESTMENT_OPTION: null,
        SELECT_MODEL_PORTFOLIO: null,
        CLEAR_INVESTMENT_OPTIONS: null,
        UPDATE_SEARCH_VISIBLE: null,
        TOGGLE_SEARCH_VISIBILITY: null,
        TOGGLE_IS_ADD_INVESTMENT_OPTION: null,
        SELECT_PORTFOLIO_BY_ID: null,
        SELECT_CONSOLIDATE_TERM_DEPOSIT: null,
        REMOVE_SELECTED_PORTFOLIO_LIST: null,
        UPDATE_INVESTMENT_ALLOCATION_ACKNOWLEDGEMENT: null,
        TOGGLE_FIRST_RATE_CASH_NON_AUTO_REBALANCING: null
    }),
    PlaceHolderMessage: {
        INVESTMENT: 'Loading model portfolio...',
        SUPER_PENSION:'Loading portfolio...',
        TRIS_OPTIONS: 'The list only displays managed account or model portfolio relevant to the pension type selected.'
    },
    FirstRateSaverNonAutoRebalancing: 805,
    FirstRateCashNonAutoRebalancing: 631,
    FirstRateTTRSaverNonAutoRebalancing: 999
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/InvestmentAllocationConstants.js